import React from 'react'
import { OrderRatingsDialog } from './OrderRatingsDialog'
import { ReadonlyOrderRating } from './OrderRatingForm/ReadonlyOrderRating'

export function ReadonlyOrderRatingsDialog ({
  onClose,
  isOpen,
  values,
  ratingFields,
}) {

  return (
    <OrderRatingsDialog
      onClose={onClose}
      isOpen={isOpen}>
      <ReadonlyOrderRating values={values}
                           onClose={onClose}
                           fields={ratingFields}/>
    </OrderRatingsDialog>
  )
}
